import { useLocation, Navigate, Outlet, useParams } from "react-router-dom";
import useEventCtx from "../hooks/useEventCtx";

const RequireFrame = () => {
    const { groupId } = useParams();
    const { event } = useEventCtx();
    const location = useLocation();

    return (
        <>
            {
                event?.frameConfigured ?
                    <Outlet />
                    :
                    <Navigate to={groupId && Object.keys(event).length === 0 ? location.pathname : '/'} state={{ from: location }} replace />
            }
        </>
    );
}

export default RequireFrame;